export default class DapiProxy {
    constructor(dapi) {
        this._dapi = dapi;
    }
    enableBypass() {
        this._isBypassEnabled = true;
    }
    disableBypass() {
        this._isBypassEnabled = false;
    }
    navigate(href) {
        this._dapi.navigate(href);
    }
    openDialog(href, height, width, absoluteValues) {
        this._dapi.openDialog(href, height, width, absoluteValues);
    }
    closeDialog() {
        this._dapi.closeDialog();
    }
    download(href) {
        this._dapi.download(href);
    }
    setContextActions(contextActions) {
        if (this._isBypassEnabled) {
            this._dapi.setContextActions(contextActions);
        }
    }
    publishTitle(string) {
        if (this._isBypassEnabled) {
            this._dapi.publishTitle(string);
        }
    }
    activateSingleResourceMode() {
        if (this._isBypassEnabled) {
            this._dapi.activateSingleResourceMode();
        }
    }
    addResourceEventListener(eventName, callback) {
        if (this._isBypassEnabled) {
            this._dapi.addResourceEventListener(eventName, callback);
        }
    }
    closeResourceIfMainResource() {
        if (this._isBypassEnabled) {
            this._dapi.closeResourceIfMainResource();
        }
    }
    deactivateSingleResourceMode() {
        if (this._isBypassEnabled) {
            this._dapi.deactivateSingleResourceMode();
        }
    }
    dispatchResourceEvent(event) {
        if (this._isBypassEnabled) {
            this._dapi.dispatchResourceEvent(event);
        }
    }
    isMainResource() {
        return this._dapi.isMainResource();
    }
    publishLocation(href) {
        if (this._isBypassEnabled) {
            this._dapi.publishLocation(href);
        }
    }
    replaceState(state) {
        if (this._isBypassEnabled) {
            this._dapi.replaceState(state);
        }
    }
    setClosable(isClosable) {
        if (this._isBypassEnabled) {
            this._dapi.setClosable(isClosable);
        }
    }
    setInterruptNavigationCallback(callback) {
        if (this._isBypassEnabled) {
            this._dapi.setInterruptNavigationCallback(callback);
        }
    }
    setResourceVisibilityChangedCallback(callback) {
        if (this._isBypassEnabled) {
            this._dapi.setResourceVisibilityChangedCallback(callback);
        }
    }
}
